import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastType } from '../models/types/toast.enum';

export interface ToastMessage {
  message: string;
  type: ToastType;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new Subject<ToastMessage>();
  toastState$ = this.toastSubject.asObservable();

  private lastToastMessage: string | null = null;
  private lastToastTimestamp = 0;
  private cooldown = 4000; // it is the time within which if another toast of same message appear then it wouldn't got duplicated

  show(message: string, type: ToastType = ToastType.Success) {
    const now = Date.now();

    if (message === this.lastToastMessage && now - this.lastToastTimestamp < this.cooldown) {
      return;
    }

    this.lastToastMessage = message;
    this.lastToastTimestamp = now;

    this.toastSubject.next({ message, type });
  }
}
